import React from 'react'

import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { ExternalProductsStatusTagRender } from '@app/components/renderers'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ExternalProductsCatalogDataSource } from '../types'

const getOptions = (): Array<Column<ExternalProductsCatalogDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(key => !['status', 'isCHTM', 'isEPP'].includes(key)) as Array<
  keyof ExternalProductsCatalogDataSource
  >

  const CustomEllipsis = {
    minWidth: '10px'
  }
  return columnsKeys.map(key => {
    return {
      customEllipsis: CustomEllipsis && true,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }
  })
}

export const getColumns = (): Array<Column<ExternalProductsCatalogDataSource>> => {
  return getColumnsFromMap<ExternalProductsCatalogDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'status',
        render: (_, { status }) => <ExternalProductsStatusTagRender status={ status } />
      },
      {
        key: 'isCHTM',
        render: (_, { isCHTM }) => (isCHTM ? 'Да' : '')
      },
      {
        key: 'isEPP',
        render: (_, { isEPP }) => (isEPP ? 'Да' : '')
      }
    ]
  })
}
